// src/features/audit/components/AuditEventCard.tsx
import { Card, formatSolarDate } from '../../../app/components/foundation';
import type { AuditEvent } from '../data/audit.mock';

export interface AuditEventCardProps {
  event: AuditEvent | undefined;
}

/**
 * Workspace card: the raw event detail for this audit record — event
 * type, the action taken, its result, and when it happened. `event`
 * comes from useAuditWorkspaceMock. Same field-list markup as
 * security/components/SecurityPolicyCard.tsx (dl-based field list).
 */
export function AuditEventCard({ event }: AuditEventCardProps) {
  return (
    <Card className="vania-audit-workspace-card">
      <h2 className="vania-audit-workspace-card-title">جزئیات رویداد</h2>

      {!event ? (
        <p className="vania-audit-workspace-empty">جزئیاتی برای این رخداد ثبت نشده است.</p>
      ) : (
        <dl className="vania-audit-workspace-fieldlist">
          <div>
            <dt>نوع رویداد</dt>
            <dd>{event.eventType}</dd>
          </div>
          <div>
            <dt>اقدام</dt>
            <dd>{event.action}</dd>
          </div>
          <div>
            <dt>نتیجه</dt>
            <dd>{event.result}</dd>
          </div>
          <div>
            <dt>زمان</dt>
            <dd dir="ltr">{formatSolarDate(event.timestamp)}</dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
